export const INSIGHT_CONFIG_LOCAL_STORAGE = 'insightsConfig'
export const NO_CALL_TYPE = 'No Call Type'
export const OFFICE_OPEN = 'OFFICE OPEN'
export const OFFICE_CLOSED = 'OFFICE CLOSED'
export const LUNCH = 'LUNCH'
export const OFFICE_DAYS = [
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
	'Sunday',
]
export const DEFAULT_OFFICE_TIMINGS = {
	starts_at: '09:00',
	ends_at: '17:00',
	lunch_starts_at: '12:00',
	lunch_ends_at: '13:00',
}
export const NOTES_MAX_LENGTH = 5000
export const COMPLETION_NOTE_MIN_LENGTH = 2
export const WMA_WEBLINK_SUCCESS_MESSAGE = 'WMA weblink copied to clipboard.'
export const WMA_WEBLINK_ERROR_MESSAGE =
	'Failed to copy WMA weblink to clipboard.'

export const BUTTON_TEXT_CHANGE_DURATION = 1500
export const COPIED_TEXT_EXPIRY_DURATION = 60000
export const COPY_BUTTON_TEXT = {
	COPY: 'Copy',
	COPIED: 'Copied',
}
export const DOWNLOAD_BUTTON_TEXT = {
	DOWNLOAD: 'Download',
	DOWNLOADED: 'Downloaded',
}

export const DOB_VALIDATION_MESSAGES = {
	INVALID_FORMAT: 'Date format requires MM/DD/YYYY.',
	INVALID_DATE: 'Please enter a valid date of birth.',
}
export const LOGIN_EXPIRY_DURATION_MS = 15 * 60 * 1000 // 15 minutes
export const LOGIN_TIMESTAMP_KEY = 'login_timestamp'
